"use strict";

import angular from "angular";

angular.module("nucont.trials", ["nucont.shared"]);
require("./signup/signup.routes");
